import { ExternalImport } from "./esbuild.worker";
import { ModuleInfo } from "@fal-works/esbuild-plugin-global-externals";

export const getGlobals = (imports?: ExternalImport[]) => {
  const globals: Record<string, ModuleInfo> = {};
  const external: string[] = [];

  if (imports)
    for (const item of imports) {
      if (item.globalName)
        globals[item.name] = {
          varName: item.globalName,
          type: "cjs"
        }
      else {
        external.push(item.name);
      }
    }

  return { globals, external };
};

export const getEnvironmentVariables = (variables?: { [name: string]: string }) => {
  if (!variables)
    return;

  const result: { [name: string]: string } = {};

  for (const variableName of Object.keys(variables)) {
    result[variableName] = JSON.stringify(variables[variableName]);
  }

  return result;
};
